import { render, staticRenderFns } from "./KAM002-v2.vue?vue&type=template&id=fc95c318"
import script from "./KAM002-v2.vue?vue&type=script&lang=ts"
export * from "./KAM002-v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports